import { queryOptions, type UseQueryOptions } from '@tanstack/react-query';
import type { DuoBalance } from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

const getBalanceUrl = 'duo/balance' as const;

export const getBalanceQueryKey = () => ['duo', 'balance'] as const;

export const getBalanceOptions = <T = DuoBalance>(
  options?: Omit<
    UseQueryOptions<DuoBalance, unknown, T>,
    'queryKey' | 'queryFn'
  >,
) => {
  return queryOptions<DuoBalance, unknown, T>({
    queryKey: getBalanceQueryKey(),
    queryFn: () => PrivateApi.get(getBalanceUrl).json<DuoBalance>(),
    staleTime: 0, // Always refetch on mount to prevent stale balance allowing extra swipes
    ...options,
  });
};
